import React from "react";
import { Link } from "react-router-dom";
import LegalPageLayout, { LegalSection } from "../components/LegalPageLayout";
import { CONTACT_ADDRESS, CONTACT_EMAIL, CONTACT_PHONE } from "../constants/contact";

export default function Privacy() {
  return (
    <LegalPageLayout
      title="Gizlilik Politikası"
      highlight="& KVKK"
      subtitle="Kişisel verilerinizin korunması ve 6698 sayılı Kanun kapsamındaki haklarınız."
      image="https://images.unsplash.com/photo-1555949963-aa79dcee981c"
    >
      <LegalSection title="1. Giriş">
        <p>
          TV13 (“Veri Sorumlusu”) olarak kişisel verilerinizin güvenliğine önem veriyoruz. Bu metin,
          6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) ve ilgili mevzuat kapsamında
          verilerinizin nasıl toplandığını, işlendiğini ve korunduğunu açıklar.
        </p>
        <p>
          Veri Sorumlusu: Ayla Şimşek Danışmanlık Şirketi — {CONTACT_ADDRESS}.
        </p>
      </LegalSection>

      <LegalSection id="kvkk" title="2. İşlenen Kişisel Veriler">
        <p>Platformumuzu kullandığınızda aşağıdaki veriler işlenebilir:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            <strong className="text-white">Kimlik ve iletişim bilgileri:</strong> ad, soyad, e-posta
            adresi (iletişim formu aracılığıyla)
          </li>
          <li>
            <strong className="text-white">İşlem güvenliği:</strong> IP adresi, tarayıcı bilgisi,
            oturum ve erişim kayıtları, çerez verileri
          </li>
          <li>
            <strong className="text-white">Canlı yayın izleme:</strong> anonim oturum kimliği ve
            izleyici sayısı için geçici teknik veriler
          </li>
        </ul>
      </LegalSection>

      <LegalSection title="3. Kişisel Verilerin İşlenme Amaçları">
        <ul className="list-disc pl-5 space-y-2">
          <li>İletişim taleplerinize yanıt vermek</li>
          <li>Platform hizmetlerini sunmak ve iyileştirmek</li>
          <li>Güvenlik, hata ayıklama ve teknik analiz yapmak</li>
          <li>Yasal yükümlülükleri yerine getirmek</li>
          <li>İstatistiksel ve anonim kullanım verilerini değerlendirmek</li>
        </ul>
      </LegalSection>

      <LegalSection title="4. Kişisel Verilerin Aktarımı">
        <p>
          Kişisel verileriniz, yalnızca hizmetin gerektirdiği durumlarda ve KVKK’ya uygun şekilde
          barındırma sağlayıcıları, e-posta hizmeti sağlayıcıları ve yasal mercilerle paylaşılabilir.
          Veriler yurt dışına aktarılması söz konusu olduğunda ilgili mevzuata uygun önlemler alınır.
        </p>
      </LegalSection>

      <LegalSection title="5. Çerezler (Cookies)">
        <p>
          Sitemiz, temel işlevler ve kullanıcı deneyimini iyileştirmek için çerezler kullanabilir.
          Tarayıcı ayarlarınızdan çerezleri yönetebilir veya devre dışı bırakabilirsiniz; bu durumda
          bazı özellikler sınırlı çalışabilir.
        </p>
      </LegalSection>

      <LegalSection title="6. Veri Güvenliği">
        <p>
          Kişisel verileriniz; yetkisiz erişim, kayıp veya ifşaya karşı teknik ve idari tedbirlerle
          korunur. Erişim yalnızca yetkili personelle sınırlandırılır.
        </p>
      </LegalSection>

      <LegalSection title="7. KVKK Kapsamındaki Haklarınız">
        <p>KVKK’nın 11. maddesi uyarınca aşağıdaki haklara sahipsiniz:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Kişisel verilerinizin işlenip işlenmediğini öğrenmek</li>
          <li>İşlenmişse buna ilişkin bilgi talep etmek</li>
          <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenmek</li>
          <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilmek</li>
          <li>Eksik veya yanlış işlenmiş verilerin düzeltilmesini istemek</li>
          <li>KVKK’da öngörülen şartlar çerçevesinde silinmesini veya yok edilmesini istemek</li>
          <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle
            aleyhinize bir sonucun ortaya çıkmasına itiraz etmek</li>
          <li>Kanuna aykırı işleme nedeniyle zarara uğramanız hâlinde zararın giderilmesini talep etmek</li>
        </ul>
      </LegalSection>

      <LegalSection title="8. Başvuru Yöntemi">
        <p>
          KVKK kapsamındaki taleplerinizi yazılı olarak veya kayıtlı elektronik posta (KEP) adresi,
          güvenli elektronik imza veya daha önce bildirdiğiniz e-posta adresiniz aracılığıyla
          iletebilirsiniz.
        </p>
        <ul className="list-none space-y-1 mt-3">
          <li>E-posta: {CONTACT_EMAIL}</li>
          <li>Telefon: {CONTACT_PHONE}</li>
          <li>Adres: {CONTACT_ADDRESS}</li>
        </ul>
        <p className="mt-3">
          Başvurularınız en geç 30 gün içinde sonuçlandırılır. İşlemin ayrıca bir maliyet
          gerektirmesi hâlinde Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifeye göre
          ücret alınabilir.
        </p>
      </LegalSection>

      <LegalSection title="9. Politika Güncellemeleri">
        <p>
          Bu Gizlilik Politikası ve KVKK aydınlatma metni gerektiğinde güncellenebilir. Güncel
          sürüm her zaman bu sayfada yayımlanır. Kullanım koşullarımız için{" "}
          <Link to="/kullanim-kosullari" className="text-[var(--tv-purple-bright)] hover:underline">
            Kullanım Koşulları
          </Link>
          sayfasına bakabilirsiniz.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
